import { Department } from "@/interfaces";
import axios from "@/plugins/axios";
import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import form from "./modules/form";

Vue.use(Vuex);

// Declaração da interface do estado raiz do store para ser importado nos módulos
export interface RootState {
  departments: Department[] | null;
  loaded: boolean;
}

export default new Vuex.Store({
  state: () => {
    return {
      departments: null,
      loaded: false
    };
  },
  mutations: {
    setDepartmentsData(state, payload) {
      const { departments } = payload;
      localStorage.setItem("departments", JSON.stringify(departments));
      state.departments = departments;
    },
    setLoaded(state, payload) {
      const { loaded } = payload;
      state.loaded = loaded; 
    }
  },
  actions: {},
  getters: {
    departments(state): Department[] | null {
      return state.departments;
    },
    loaded(state): boolean {
      return state.loaded;
    }
  },
  modules: {
    auth,
    form,
  },
});
